import { useParams, useNavigate } from "react-router-dom"

/**
 * Extrait le orgSlug depuis les paramètres d'URL.
 * À utiliser dans tout composant rendu sous la route /:orgSlug/*.
 */
export function useCurrentOrg(): string {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  return orgSlug || ""
}

/**
 * Construit un chemin préfixé par le orgSlug courant.
 * Exemple : orgPath("mon-org", "/training/programs") => "/mon-org/training/programs"
 */
export function orgPath(orgSlug: string, path: string): string {
  const normalizedPath = path.startsWith("/") ? path : "/" + path
  if (!orgSlug) return normalizedPath
  return `/${orgSlug}${normalizedPath}`
}

/**
 * Hook qui retourne une fonction navigate préfixant automatiquement le orgSlug.
 * Usage : const navigateOrg = useOrgNavigate(); navigateOrg("/training/programs")
 */
export function useOrgNavigate() {
  const navigate = useNavigate()
  const slug = useCurrentOrg()
  return (path: string, options?: { replace?: boolean }) => {
    navigate(orgPath(slug, path), options)
  }
}
